/**
 * Created by ObadaDarwish on 28/12/2017.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'orderBy'})

export class orderByPipe implements PipeTransform {
  
  transform(arenas: any, key?: any): any {
    if (arenas) {
      if (key) {
        arenas.sort(function (ArenaA, ArenaB) {
          let gameA = ArenaA[key];
          let gameB = ArenaB[key];
          if (gameA > gameB) {
            return 1;
          } else if (gameA < gameB) {
            return -1;
          } else {
            return 0;
          }
        });
      }
      return arenas;
    }
  }
}
